import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const VideoIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 21)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M.5.5h20v20H.5z" />
      <path d="M8.21 11.65a.5.5 0 0 1-.46 0 .41.41 0 0 1-.22-.36V6.04a.41.41 0 0 1 .22-.36.5.5 0 0 1 .46 0l5.03 2.62a.4.4 0 0 1 0 .73zM2.88 16.5h15.24M13.83 15.74v2.38" />
    </SVG>
  );
};
